var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M6.666 10.667c0 .366-.3.666-.666.666-.367 0-.667-.3-.667-.666V8c0-.367.3-.667.667-.667.366 0 .666.3.666.667v2.667zm4 0c0 .366-.3.666-.666.666-.367 0-.667-.3-.667-.666V8c0-.367.3-.667.667-.667.366 0 .666.3.666.667v2.667zm1.334 2c0 .367-.299.666-.667.666H4.666c-.368 0-.666-.299-.666-.666V5.333h8v7.334zM6.666 2.885c0-.103.143-.218.334-.218h2c.19 0 .333.115.333.218V4H6.666V2.885zM14 4H10.666V2.885c0-.856-.747-1.552-1.666-1.552H7c-.92 0-1.667.696-1.667 1.552V4H2c-.367 0-.667.3-.667.667 0 .366.3.666.667.666h.666v7.334c0 1.102.898 2 2 2h6.667c1.103 0 2-.898 2-2V5.333H14c.366 0 .666-.3.666-.666 0-.367-.3-.667-.666-.667z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.6560bfc9.svg";
export { ForwardRef as ReactComponent };